(function() {
  'use strict';

  const CONFIG = {
    apiEndpoint: '/apps/DiscountCalc', // Shopify App Proxy endpoint
    debounceMs: 500,
    retryAttempts: 2,
    retryDelayMs: 1000
  };

  let debounceTimer = null;
  let isCalculating = false;
  let currentDiscount = { amount: 0, percent: 0 };

  function getProductMetafields(variantId) {
    const metafields = {
      weight: null,
      height: null,
      width: null,
      length: null,
      listprice: null
    };
    
    const inputs = document.querySelectorAll('input[data-variant-id="' + variantId + '"]');
    
    inputs.forEach(function(input) {
      const value = input.value;
      
      if (input.hasAttribute('data-weight')) {
        metafields.weight = value;
      }
      if (input.hasAttribute('data-height')) {
        metafields.height = value;
      }
      if (input.hasAttribute('data-width')) {
        metafields.width = value;
      }
      if (input.hasAttribute('data-length')) {
        metafields.length = value;
      }
      if (input.hasAttribute('data-listprice')) {
        metafields.listprice = value;
      }


    });
    
    return metafields;
  }

  async function fetchCartWithMetafields() {
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      console.log('Cart items:', cart.items.length);
      
      cart.items = cart.items.map(function(item) {
        const metafields = getProductMetafields(item.variant_id);
        
        return {
          variant_id: item.variant_id,
          quantity: item.quantity,
          product_title: item.product_title,
          metafields: metafields
        };
      });
      
      return cart;
    } catch (error) {
      console.error('Error fetching cart:', error);
      throw error;
    }
  }

  async function fetchDiscountFromAPI(cartData, attempt) {
    attempt = attempt || 1;
    
    try {
      const items = [];
      
      cartData.items.forEach(function(item) {
        const weight = parseFloat(item.metafields.weight) || 0;
        const height = parseFloat(item.metafields.height) || 0;
        const width = parseFloat(item.metafields.width) || 0;
        const length = parseFloat(item.metafields.length) || 0;
        const listprice  = parseFloat(item.metafields.listprice) || 0;
        
        const dims = [length, width, height].sort(function(a, b) { return b - a; });
        
        for (let i = 0; i < item.quantity; i++) {
          items.push({
            dim1: dims[0] || 0,
            dim2: dims[1] || 0,
            dim3: dims[2] || 0,
            weight: weight,
            listprice: listprice
          });
        }
      });
      
      const payload = { items: items };
      

      const response = await fetch(CONFIG.apiEndpoint, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });

       const data = await response.json();  
      if (!response.ok) {
       
        throw new Error('API returned ' + response.status);
      }

      
      const discountAmount = Math.round((data.discountAmount || 0) * 100);
      
      const discountPercent = cartData.items_subtotal_price > 0 
        ? Math.round((discountAmount / cartData.items_subtotal_price) * 100)
        : 0;
      
      
      return {
        amount: discountAmount,
        percent: discountPercent,
        finalTotal: cartData.total_price - discountAmount
      };

    } catch (error) {
      console.error('❌ Discount API error (attempt ' + attempt + '):', error);
      
      if (attempt < CONFIG.retryAttempts) {
        console.log('⏳ Retrying in ' + CONFIG.retryDelayMs + 'ms...');
        await sleep(CONFIG.retryDelayMs);
        return fetchDiscountFromAPI(cartData, attempt + 1);
      }
      
      console.error('❌ All retry attempts failed');
      return { amount: 0, percent: 0, finalTotal: cartData.total_price };
    }
  }

  async function recalculateDiscount() {
    if (isCalculating) return;
    
    isCalculating = true;
    updateDiscountUI('calculating');

    try {
      const cart = await fetchCartWithMetafields();
      
      if (cart.item_count === 0) {
        currentDiscount = { amount: 0, percent: 0, finalTotal: 0 };
        updateDiscountUI('none');
        updateCartTotals(cart, currentDiscount);
        return;
      }

      const discount = await fetchDiscountFromAPI(cart);
      currentDiscount = discount;

      if (discount.amount > 0) {
        updateDiscountUI('applied', discount);
      } else {
        updateDiscountUI('none');
      }
      
      updateCartTotals(cart, discount);

    } catch (error) {
      console.error('Error recalculating discount:', error);
      updateDiscountUI('error');
      currentDiscount = { amount: 0, percent: 0 };
    } finally {
      isCalculating = false;
    }
  }

  function scheduleRecalculation() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(recalculateDiscount, CONFIG.debounceMs);
  }

  function updateDiscountUI(status, discount) {
    const container = document.querySelector('[data-dynamic-discount]');
    if (!container) return;

    const amountEl = container.querySelector('[data-discount-amount]');
    const labelEl = container.querySelector('[data-discount-label]');

    switch (status) {
      case 'calculating':
        container.style.display = 'block';
        if (labelEl) labelEl.textContent = 'מחשב מחדש את ההנחה...';
        if (amountEl) amountEl.textContent = '';
        container.classList.add('calculating');
        break;

      case 'applied':
        container.style.display = 'block';
        container.classList.remove('calculating');
        
        if (labelEl) {
          const text = 'שולחים יותר, חוסכים יותר';
          labelEl.innerHTML = '<i aria-hidden="true" class="icon-label"></i> ' + text;
        }
        
        if (amountEl) {
          const formatted = formatMoney(discount.amount);
          amountEl.textContent = '-' + formatted;
        }
        break;

       case 'none':
        container.style.display = 'block'; // Keep visible
        container.classList.remove('calculating');
        
        if (labelEl) {
          const text = 'הוסיפו פריטים נוספים לעגלת הקניות לקבלת ההנחה';
          labelEl.innerHTML = '<i aria-hidden="true" class="icon-label"></i> ' + text;
        }
        
        if (amountEl) {
          amountEl.textContent = ''; // Clear amount
        }
        break; // IMPORTANT: Add break here!
        

      case 'error':
        container.style.display = 'none';
        container.classList.remove('calculating');
        break;
    }
  }

  function updateCartTotals(cart, discount) {
    const originalTotalElements = document.querySelectorAll('[data-original-cart-total]');
    originalTotalElements.forEach(function(el) {
      if (discount.amount > 0) {
        el.classList.add('has-discount');
      } else {
        el.classList.remove('has-discount');
      }
    });

    const newTotalElements = document.querySelectorAll('[data-cart-total-with-discount]');
    newTotalElements.forEach(function(el) {
      const finalTotal = cart.total_price - discount.amount;
      el.textContent = formatMoney(finalTotal);
    });

    const discountInput = document.querySelector('[data-discount-input]');
    if (discountInput) {
      discountInput.value = (discount.amount / 100).toFixed(2);
    }

    const finalTotalInput = document.querySelector('[data-final-total-input]');
    if (finalTotalInput) {
      const finalTotal = (cart.total_price - discount.amount) / 100;
      finalTotalInput.value = finalTotal.toFixed(2);
    }
  }

  function initializeEventListeners() {
    document.addEventListener('cart:updated', scheduleRecalculation);
    document.addEventListener('cart:refresh', scheduleRecalculation);
    
    const originalFetch = window.fetch;
    window.fetch = function() {
      const url = arguments[0];
      
      if (typeof url === 'string' && (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
      )) {
        return originalFetch.apply(this, arguments).then(function(response) {
          scheduleRecalculation();
          return response;
        });
      }
      
      return originalFetch.apply(this, arguments);
    };

    const shippingInputs = document.querySelectorAll('[name*="address"], [name*="zip"], [name*="country"]');
    shippingInputs.forEach(function(input) {
      input.addEventListener('change', scheduleRecalculation);
    });

    if (document.querySelector('[data-dynamic-discount]')) {
      scheduleRecalculation();
    }
  }

  function formatMoney(cents) {
    const amount = cents / 100;
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency
    }).format(amount);
  }

  function sleep(ms) {
    return new Promise(function(resolve) {
      setTimeout(resolve, ms);
    });
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    
    const metafieldInputs = document.querySelectorAll('input[data-weight], input[data-height], input[data-width], input[data-length], input[data-listprice]');
    console.log('Found ' + metafieldInputs.length + ' metafield inputs');
    
    if (metafieldInputs.length === 0) {
      console.warn('⚠️ No metafield inputs found!');
    } else {
      console.log('✓ Metafield inputs found');
    }
    
    initializeEventListeners();
  }

  init();

})();